import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { accountsRoute } from 'src/app/app-routing.module';

@Directive()
export abstract class DetailView {
   @Input() isSystemUser: boolean;

   @Input() selectedAccountName: string | null;

   @Input() isOnSystemPage: boolean;

   @Output() navigateUp = new EventEmitter<string | number>();

   @Output() navigateDown = new EventEmitter<string | number>();

   accountsRoute = `/${accountsRoute}`;
}

@Directive()
export abstract class NavigatableDetailView extends DetailView {
   @Input() idsFromRegister: string[] | number[];

   @Input() totalCount: number;

   @Output() loadIdPage = new EventEmitter<void>();

   get indexDisplay(): string {
      {
         if (!this.entityId || !this.idsFromRegister?.length) {
            return '';
         }

         const index = this.idsFromRegister.findIndex((id) => id === this.entityId);

         if (index === -1) {
            return '';
         }

         return `${index + 1} of ${this.totalCount}`;
      }
   }

   abstract get entityId(): number | string | null;

   get hasNavigateUp(): boolean {
      const indexOfCurrentAccount = this.idsFromRegister.findIndex((id) => id === this.entityId);
      return indexOfCurrentAccount !== 0;
   }

   get hasNavigateDown(): boolean {
      const indexOfCurrentAccount = this.idsFromRegister.findIndex((id) => id === this.entityId);
      return indexOfCurrentAccount !== this.totalCount - 1;
   }

   onNavigateUp() {
      const currentIndex = this.idsFromRegister.findIndex((id) => id === this.entityId);
      this.navigateUp.emit(this.idsFromRegister[currentIndex - 1]);
   }

   onNavigateDown() {
      const currentIndex = this.idsFromRegister.findIndex((id) => id === this.entityId);
      this.navigateDown.emit(this.idsFromRegister[currentIndex + 1]);
      if (this.idsFromRegister.length - currentIndex < 5 && this.totalCount > this.idsFromRegister.length) {
         this.loadIdPage.emit();
      }
   }
}
